import React from 'react';
import { PRIORITY_LABELS } from '../constants/cardConstants';
import { Labels, Label, LabelText } from '../styles/Card.styles';

const CardLabels = ({ card, labels, areLabelsExpanded, onToggleLabels }) => {
    const cardLabels = labels.filter(label => card.labelIds?.includes(label.id));

    return (
        <Labels onClick={(e) => {
            e.stopPropagation();
            onToggleLabels();
        }}>
            {card.priority && PRIORITY_LABELS[card.priority] && (
                <Label
                    color={PRIORITY_LABELS[card.priority].color}
                    expanded={areLabelsExpanded}
                    title={PRIORITY_LABELS[card.priority].label}
                >
                    <LabelText expanded={areLabelsExpanded}>
                        {PRIORITY_LABELS[card.priority].label}
                    </LabelText>
                </Label>
            )}
            {cardLabels.map(label => (
                <Label
                    key={label.id}
                    color={label.color}
                    expanded={areLabelsExpanded}
                    title={label.title}
                >
                    <LabelText expanded={areLabelsExpanded}>
                        {label.title}
                    </LabelText>
                </Label>
            ))}
        </Labels>
    );
};

export default CardLabels;
